import { useCallback } from 'react';
import Cookies from 'universal-cookie';

export const useCookieAuth = () => {
    const cookies = new Cookies();
    return { cookieAuthCheck: useCallback(() => cookies.get('user') || null, [cookies]) };
};

export const useCookieSetUser = () => {
    const cookies = new Cookies();
    return {
        cookieSetUser: useCallback(
            (data) => {
                cookies.set('user', data !== null ? data : '');
            },
            [cookies],
        ),
    };
};

export default useCookieAuth;
